import React from 'react';
import { Spin } from 'antd';

const LazyInvoiceOverduePage = React.lazy(() => import('./Invoice/InvoiceOverdue'));
export const AsyncInvoiceOverduePage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyInvoiceOverduePage />
	</React.Suspense>
);

const LazyInvoiceOverdueInvoicesPage = React.lazy(() => import('./Invoice/Invoices'));
export const AsyncInvoiceOverdueInvoicesPage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyInvoiceOverdueInvoicesPage />
	</React.Suspense>
);

const LazyCreditCardOverduePage = React.lazy(
	() => import('./CreditCard/CreditCardOverdue')
);
export const AsyncCreditCardOverduePage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyCreditCardOverduePage />
	</React.Suspense>
);

const LazyUpdateCreditCardPage = React.lazy(
	() => import('./CreditCard/UpdateCreditCard')
);
export const AsyncUpdateCreditCardPage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyUpdateCreditCardPage />
	</React.Suspense>
);

const LazyCreditCardOverduePayStatusPage = React.lazy(
	() => import('./CreditCard/Status')
);
export const AsyncCreditCardOverduePayStatusPage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyCreditCardOverduePayStatusPage />
	</React.Suspense>
);
